module.exports = __webpack_public_path__ + "static/img/4_v3.e145ba0a.png";